import React from 'react'

export const Background = () => <div>Background settings</div>
